import { jsPDF } from 'jspdf';

export function generatePaymentPDF(payment) {
  if (!payment) return;
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();
  let y = 60;

  // Title
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor('#222');
  doc.text('Payment Receipt', pageWidth / 2, y, { align: 'center' });
  y += 24;

  // Horizontal line
  doc.setDrawColor('#29a3ec');
  doc.setLineWidth(2);
  doc.line(60, y, pageWidth - 60, y);
  y += 30;

  // Details box background
  const boxX = 60;
  const boxY = y;
  const boxWidth = pageWidth - 120;
  const boxHeight = 260;
  doc.setFillColor('#f7fafd');
  doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 6, 6, 'F');

  // Table layout
  const labelX = boxX + 20;
  const valueX = boxX + 160;
  let rowY = boxY + 32;
  const rowGap = 28;
  const labelColor = '#222';
  const valueColor = '#222';
  const labelFontSize = 12;
  const valueFontSize = 12;

  // Fields
  const fields = [
    ['Patient Name:', payment.patient?.name || payment.patientName || payment.name || 'Unknown'],
    ['Patient Email:', payment.patient?.email || payment.patientEmail || payment.email || 'No email'],
    ['Payment Type:', payment.paymentType || payment.type || 'Unknown'],
    ['Amount:', payment.amount ?
      (typeof payment.amount === 'string'
        ? `${payment.currency?.toUpperCase() || 'AUD'} $${payment.amount}`
        : new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: payment.currency?.toUpperCase() || 'AUD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(payment.amount))
      : 'AUD $0'],
    ['Payment Method:', payment.method || payment.paymentMethod || 'Unknown'],
    ['Status:', payment.status || 'Unknown'],
    ['Date:', payment.date ? new Date(payment.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : 'No date'],
    ['Transaction ID:', payment._id || payment.id || 'N/A'],
  ];

  fields.forEach(([label, value]) => {
    doc.setFontSize(labelFontSize);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(labelColor);
    doc.text(label, labelX, rowY);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(valueColor);
    doc.text(String(value), valueX, rowY);
    rowY += rowGap;
  });

  doc.save(`payment-${payment._id || payment.id || 'receipt'}.pdf`);
} 